import React from 'react';
import APickerView from 'antd-mobile/lib/picker-view';



export default class PickerView extends APickerView {}